import { render, staticRenderFns } from "./WhatWedo.vue?vue&type=template&id=af0adf7c&scoped=true&"
import script from "./WhatWedo.vue?vue&type=script&lang=js&"
export * from "./WhatWedo.vue?vue&type=script&lang=js&"
import style0 from "./WhatWedo.vue?vue&type=style&index=0&id=af0adf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0adf7c",
  null
  
)

export default component.exports